export default "__VITE_ASSET__DUq53xyD__"